import { useContext } from "react";
import { LightboxContext } from "../context";

/**
 * Hook to access the Lightbox context.
 * Must be used within a Lightbox component.
 * @throws Error if used outside of Lightbox
 */
export const useLightboxContext = () => {
    const context = useContext(LightboxContext);
    if (!context) {
        throw new Error("Lightbox components must be used within a Lightbox");
    }
    return context;
};

/**
 * Public hook to access the Lightbox context.
 * Returns null if used outside of a Lightbox — safe for optional consumption.
 */
export const useLightbox = () => useContext(LightboxContext);
